var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "appDetail"
  }, [_vm.detailLoading ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _c('Back', {
    attrs: {
      "type": "close",
      "btnone": true,
      "text": _vm.detail.name
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.showPoptip ? _c('Poptip', {
    staticClass: "poptip",
    attrs: {
      "trigger": "hover",
      "word-wrap": "",
      "placement": "left",
      "width": "300",
      "transfer": ""
    }
  }, [_c('Icon', {
    staticClass: "help_icon",
    attrs: {
      "type": "ios-help-circle-outline"
    }
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v($t("gnknugl", "1、第一次先从钉钉同步 数据覆盖iWork"))]), _c('p', [_vm._v($t("lbibxit", "2、之后iWork修改通讯录内容会实时同步更新 钉钉通讯录"))]), _c('p', [_vm._v($t("t6nb3un", "3、用户操作界面， 可选择自动同步或手动同步。"))])])], 1) : _vm._e()], 1), _c('Tabs', {
    model: {
      value: _vm.tabValue,
      callback: function ($$v) {
        _vm.tabValue = $$v;
      },
      expression: "tabValue"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": $t("blh1h04", "基础信息"),
      "name": "name1"
    }
  }, [_c('AppDetailTab1', {
    attrs: {
      "item": _vm.item,
      "detail": _vm.detail,
      "downAddress": _vm.downAddress,
      "scopeList": _vm.scopeList
    },
    on: {
      "on-update": _vm.getAppDetail,
      "on-change-user": _vm.onChangeUser
    }
  })], 1), _vm.isAzure ? [_c('TabPane', {
    attrs: {
      "label": $t("c72yjo4", "密钥管理")
    }
  }, [_c('AppDetailTabAzure', {
    attrs: {
      "detail": _vm.detail
    }
  })], 1)] : _vm._e(), _vm.isDingDing || _vm._third ? [_c('TabPane', {
    attrs: {
      "label": $t("cf0f484", "应用凭证"),
      "name": "name2"
    }
  }, [_vm.isDingDing ? _c('AppDetailTab2', {
    attrs: {
      "item": _vm.item,
      "detail": _vm.detail
    }
  }) : _c('AppDetailTab2Third', {
    attrs: {
      "detail": _vm.detail
    }
  })], 1), _c('TabPane', {
    attrs: {
      "label": $t("dnhnle4", "权限管理"),
      "name": "name3"
    }
  }, [_vm.isDingDing ? _c('AppDetailTab3') : _c('AppDetailTab3Third')], 1), _c('TabPane', {
    attrs: {
      "label": $t("cf8e224", "应用自检"),
      "name": "name4"
    }
  }, [_c('AppDetailTab4', {
    attrs: {
      "detail": _vm.detail
    }
  })], 1)] : _vm._e(), _vm._third || _vm._isOperaCloud ? [_c('TabPane', {
    attrs: {
      "label": $t("iwitmt4", "部门管理"),
      "name": "name5"
    }
  }, [_vm.tabValue === 'name5' ? _c('AppDetailTab5', {
    attrs: {
      "detail": _vm.detail
    }
  }) : _vm._e()], 1), _c('TabPane', {
    attrs: {
      "label": $t("hxhx7p4", "角色管理"),
      "name": "name6"
    }
  }, [_vm.tabValue === 'name6' ? _c('AppDetailTab6', {
    attrs: {
      "detail": _vm.detail
    }
  }) : _vm._e()], 1)] : _vm._e(), _vm._isOperaCloud ? [_c('TabPane', {
    attrs: {
      "label": $t("cf0irm4", "应用参数"),
      "name": "name7"
    }
  }, [_vm.tabValue === 'name7' ? _c('AppDetailTab7', {
    attrs: {
      "detail": _vm.detail
    }
  }) : _vm._e()], 1), _c('TabPane', {
    attrs: {
      "label": $t("d7kdp34", "数据同步"),
      "name": "name8"
    }
  }, [_vm.tabValue === 'name8' ? _c('AppDetailTab8', {
    attrs: {
      "detail": _vm.detail
    }
  }) : _vm._e()], 1)] : _vm._e()], 2), _c('AppDetailBindModal', {
    ref: "AppDetailBindModal",
    attrs: {
      "item": _vm.item,
      "detail": _vm.detail,
      "scopeList": _vm.scopeList
    },
    on: {
      "on-update": _vm.getAppDetail
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };